import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useStore } from "vuex";
import CustomAlert from "@/components/alert/CustomAlert.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const alertInfo = store.getters.getAlert;
const alert = (data: any) => {
  store.commit("alert", { title: data.title, msg: data.msg, sCb: data.sCb });
};
const confirm = (data: any) => {
  store.commit("confirm", { title: data.title, msg: data.msg, sCb: data.sCb, fCb: data.fCb });
};
window.customAlert = alert;
window.customConfirm = confirm;

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (_unref(alertInfo).show)
      ? (_openBlock(), _createBlock(CustomAlert, {
          key: 0,
          title: _unref(alertInfo).title,
          msg: _unref(alertInfo).msg,
          type: _unref(alertInfo).type,
          sCb: _unref(alertInfo).sCb,
          fCb: _unref(alertInfo).fCb
        }, null, 8, ["title", "msg", "type", "sCb", "fCb"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})